export * from './lib/user-avatar.module';
